import { Link, useLocation } from 'react-router-dom'
import { Compass, Home } from 'lucide-react'
import { buttonStyles, Card, EmptyState } from '../components/ui'

export default function NotFound() {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-surface-base flex items-center justify-center p-6">
      <Card className="max-w-md w-full" elevation="floating">
        <EmptyState
          icon={<Compass size={28} />}
          title={
            <>
              <span className="font-display text-5xl text-ink block mb-1">404</span>
              Page not found
            </>
          }
          description={
            <>
              No route matched <code className="font-mono text-ink">{location.pathname}</code>.
              The link may be broken, or the page may have moved.
            </>
          }
          action={
            <Link to="/" className={buttonStyles({ variant: 'primary', size: 'md' })}>
              <Home size={16} className="mr-2 -ml-0.5" />
              Back to dashboard
            </Link>
          }
        />
      </Card>
    </div>
  )
}
